import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Label, TextInput, Select, Card } from "flowbite-react";
import { UserPlus, Store, Database, Users } from "lucide-react";
//modals
import { SuccessModal } from "../Common/SucessModal";
import { ErrorModal } from "../Common/ErrorModal";
// import { toast } from "react-hot-toast";
import { Spinner } from "flowbite-react";

export const CreateUserPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [userType, setUserType] = useState("");
  const [franchises, setFranchises] = useState([]);
  const [posAgents, setPosAgents] = useState([]);
  const [mvnos, setMvnos] = useState([]);
  const [resellers, setResellers] = useState([]);
  const [commercials, setCommercials] = useState([]);

  // POS Application Form Data
  const [posFormData, setPosFormData] = useState({
    username: "",
    password: "",
    role: "PDV",
    firstName: "",
    lastName: "",
    cin: "",
    phone: "",
    email: "",
    mvnoId: "",
    resellerId: "",
    franchiseId: "",
    contatType2Id: "",
  });

  // Stock Management Form Data
  const [stockFormData, setStockFormData] = useState({
    username: "",
    password: "",
    role: "PDV",
    firstName: "",
    lastName: "",
    owner: "",
    franchiseId: "",
  });

  // Commercial Form Data
  const [commercialFormData, setCommercialFormData] = useState({
    username: "",
    password: "",
    role: "COMMERCIAL",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    cin: "",
    stockTotal: 0,
    administratifDeVenteId: "",
    resellerId: "",
    mvnoId: "",
  });

  // Franchise Form Data
  const [franchiseFormData, setFranchiseFormData] = useState({
    franchiseName: "",
    firstName: "",
    lastName: "",
    address: "",
    phone: "",
    resellerId: "",
    username: "",
    password: "",
    commercialId: "",
    latitude: "",
    longitude: "",
    governorate: "",
  });

  useEffect(() => {
    // Fetch franchises, POS agents, MVNOs, and resellers
    const fetchData = async () => {
      try {
        const [franchisesRes, mvnosRes, resellersRes, commercialsRes] =
          await Promise.all([
            axios.get(`${process.env.REACT_APP_BACKEND_URL}getShops`, {
              withCredentials: true,
            }),
            axios.get(`${process.env.REACT_APP_BACKEND_URL}getMVNOs`, {
              withCredentials: true,
            }),
            axios.get(`${process.env.REACT_APP_BACKEND_URL}getResellers`, {
              withCredentials: true,
            }),
            axios.get(
              `${process.env.REACT_APP_BACKEND_URL}getAllCommercialsByAdmin`,
              { withCredentials: true },
            ),
          ]);

        setFranchises(franchisesRes?.data);
        setMvnos(mvnosRes?.data);
        setResellers(resellersRes?.data);
        setCommercials(commercialsRes?.data);
        console.log(resellersRes);
      } catch (err) {
        console.log("ERROR", err);
        setError("Failed to load data");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    console.log("FRANCHISES", franchises);
    console.log("MVNO", mvnos);
    console.log("RESELLERS", resellers);
  }, [franchises, mvnos, resellers]);

  const handlePosSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}createPdv`,
        posFormData,
        { withCredentials: true },
      );
      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create POS user");
    } finally {
      setLoading(false);
    }
  };

  const handleCommercialSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}createCommercial`,
        commercialFormData,
        { withCredentials: true },
      );
      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to create commercial user",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFranchiseSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}createFranchise`,
        franchiseFormData,
        { withCredentials: true },
      );

      if (response.data) {
        setSuccess(true);
        // navigate(-1);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error creating franchise");
    } finally {
      setLoading(false);
    }
  };

  const handlePosChange = (e) => {
    const { name, value } = e.target;
    setPosFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStockChange = (e) => {
    const { name, value } = e.target;
    setStockFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCommercialChange = (e) => {
    const { name, value } = e.target;
    setCommercialFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFranchiseChange = (e) => {
    const { name, value } = e.target;
    setFranchiseFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const renderForm = () => {
    switch (userType) {
      case "PDV":
        return (
          <div className="grid grid-cols-1 gap-6">
            <Card>
              <div className="flex items-center gap-2 mb-6">
                <Store className="h-6 w-6 text-blue-600" />
                <h2 className="text-xl font-semibold">
                  Création d'un point de vente
                </h2>
              </div>

              <form onSubmit={handlePosSubmit} className="space-y-4">
                <div className="grid gap-6 md:grid-cols-2">
                  <div>
                    <Label htmlFor="pos-username">Username</Label>
                    <TextInput
                      id="pos-username"
                      name="username"
                      value={posFormData.username}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-password">Password</Label>
                    <TextInput
                      id="pos-password"
                      name="password"
                      type="password"
                      value={posFormData.password}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-firstName">First Name</Label>
                    <TextInput
                      id="pos-firstName"
                      name="firstName"
                      value={posFormData.firstName}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-lastName">Last Name</Label>
                    <TextInput
                      id="pos-lastName"
                      name="lastName"
                      value={posFormData.lastName}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-cin">CIN</Label>
                    <TextInput
                      id="pos-cin"
                      name="cin"
                      value={posFormData.cin}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-phone">Phone</Label>
                    <TextInput
                      id="pos-phone"
                      name="phone"
                      value={posFormData.phone}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-email">Email</Label>
                    <TextInput
                      id="pos-email"
                      name="email"
                      type="email"
                      value={posFormData.email}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-contactType2Id">
                      ContactType2ID
                    </Label>
                    <TextInput
                      id="pos-contactType2Id"
                      name="contatType2Id"
                      value={posFormData.contatType2Id}
                      onChange={handlePosChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="pos-mvno">MVNO</Label>
                    <Select
                      id="pos-mvno"
                      name="mvnoId"
                      value={posFormData.mvnoId}
                      onChange={handlePosChange}
                      required
                    >
                      <option value="">Select MVNO</option>
                      {mvnos?.map((mvno) => (
                        <option key={mvno._id} value={mvno._id}>
                          {mvno.name}
                        </option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="pos-reseller">Reseller</Label>
                    <Select
                      id="pos-reseller"
                      name="resellerId"
                      value={posFormData.resellerId}
                      onChange={handlePosChange}
                      required
                    >
                      <option value="">Select Reseller</option>
                      {resellers?.map((reseller) => (
                        <option key={reseller._id} value={reseller._id}>
                          {reseller.name}
                        </option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="pos-franchise">Franchise</Label>
                    <Select
                      id="pos-franchise"
                      name="franchiseId"
                      value={posFormData.franchiseId}
                      onChange={handlePosChange}
                      required
                    >
                      <option value="">Select Franchise</option>
                      {franchises?.map((franchise) => (
                        <option key={franchise._id} value={franchise._id}>
                          {franchise.name}
                        </option>
                      ))}
                    </Select>
                  </div>
                </div>

                <div className="flex justify-end gap-4 mt-6">
                  <Button
                    color="gray"
                    onClick={() => navigate("/Utilisateurs")}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" color="blue" disabled={loading}>
                    {loading ? "Creating..." : "Create PDV"}
                  </Button>
                </div>
              </form>
            </Card>
          </div>
        );

      case "COMMERCIAL":
        return (
          <Card>
            <div className="flex items-center gap-2 mb-6">
              <Users className="h-6 w-6 text-purple-600" />
              <h2 className="text-xl font-semibold">
                Création d'un utilisateur Commercial
              </h2>
            </div>

            <form onSubmit={handleCommercialSubmit} className="space-y-4">
              <div className="grid gap-6 md:grid-cols-2">
                {/* Account Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Account Information
                  </h3>

                  <div>
                    <Label htmlFor="commercial-username">Username</Label>
                    <TextInput
                      id="commercial-username"
                      name="username"
                      value={commercialFormData.username}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="commercial-password">Password</Label>
                    <TextInput
                      id="commercial-password"
                      name="password"
                      type="password"
                      value={commercialFormData.password}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>
                </div>

                {/* Personal Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Personal Information
                  </h3>

                  <div>
                    <Label htmlFor="commercial-firstName">First Name</Label>
                    <TextInput
                      id="commercial-firstName"
                      name="firstName"
                      value={commercialFormData.firstName}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="commercial-lastName">Last Name</Label>
                    <TextInput
                      id="commercial-lastName"
                      name="lastName"
                      value={commercialFormData.lastName}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="commercial-cin">CIN</Label>
                    <TextInput
                      id="commercial-cin"
                      name="cin"
                      value={commercialFormData.cin}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>
                </div>

                {/* Contact Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Contact Information
                  </h3>

                  <div>
                    <Label htmlFor="commercial-email">Email</Label>
                    <TextInput
                      id="commercial-email"
                      name="email"
                      type="email"
                      value={commercialFormData.email}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="commercial-phone">Phone Number</Label>
                    <TextInput
                      id="commercial-phone"
                      name="phoneNumber"
                      value={commercialFormData.phoneNumber}
                      onChange={handleCommercialChange}
                      required
                    />
                  </div>
                </div>

                {/* Business Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Business Information
                  </h3>

                  <div>
                    <Label htmlFor="commercial-reseller">Reseller</Label>
                    <Select
                      id="commercial-reseller"
                      name="resellerId"
                      value={commercialFormData.resellerId}
                      onChange={handleCommercialChange}
                      required
                    >
                      <option value="">Select a reseller</option>
                      {resellers.map((reseller) => (
                        <option key={reseller._id} value={reseller._id}>
                          {reseller.name}
                        </option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="commercial-mvno">MVNO</Label>
                    <Select
                      id="commercial-mvno"
                      name="mvnoId"
                      value={commercialFormData.mvnoId}
                      onChange={handleCommercialChange}
                      required
                    >
                      <option value="">Select an MVNO</option>
                      {mvnos.map((mvno) => (
                        <option key={mvno._id} value={mvno._id}>
                          {mvno.name}
                        </option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-6">
                <Button color="gray" onClick={() => navigate("/users")}>
                  Cancel
                </Button>
                <Button color="blue" type="submit" disabled={loading}>
                  {loading ? "Creating..." : "Create Commercial "}
                </Button>
              </div>
            </form>
          </Card>
        );

      case "FRANCHISE":
        return (
          <Card>
            <div className="flex items-center gap-2 mb-6">
              <Store className="h-6 w-6 text-orange-600" />
              <h2 className="text-xl font-semibold">
                Création d'un utilisateur Franchise
              </h2>
            </div>

            <form onSubmit={handleFranchiseSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Franchise Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Franchise Information
                  </h3>

                  <div>
                    <Label htmlFor="franchiseName">Franchise Name</Label>
                    <TextInput
                      id="franchiseName"
                      name="franchiseName"
                      value={franchiseFormData.franchiseName}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="firstName">First Name</Label>
                    <TextInput
                      id="firstName"
                      name="firstName"
                      value={franchiseFormData.firstName}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="lastName">Last Name</Label>
                    <TextInput
                      id="lastName"
                      name="lastName"
                      value={franchiseFormData.lastName}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="governorate">Governorate</Label>
                    <Select
                      id="governorate"
                      name="governorate"
                      value={franchiseFormData.governorate}
                      onChange={handleFranchiseChange}
                      required
                    >
                      <option value="">Select a governorate</option>
                      <option value="Ariana">Ariana</option>
                      <option value="Béja">Béja</option>
                      <option value="Ben Arous">Ben Arous</option>
                      <option value="Bizerte">Bizerte</option>
                      <option value="Gabès">Gabès</option>
                      <option value="Gafsa">Gafsa</option>
                      <option value="Jendouba">Jendouba</option>
                      <option value="Kairouan">Kairouan</option>
                      <option value="Kasserine">Kasserine</option>
                      <option value="Kébili">Kébili</option>
                      <option value="Kef">Kef</option>
                      <option value="Mahdia">Mahdia</option>
                      <option value="Manouba">Manouba</option>
                      <option value="Médenine">Médenine</option>
                      <option value="Monastir">Monastir</option>
                      <option value="Nabeul">Nabeul</option>
                      <option value="Sfax">Sfax</option>
                      <option value="Sidi Bouzid">Sidi Bouzid</option>
                      <option value="Siliana">Siliana</option>
                      <option value="Sousse">Sousse</option>
                      <option value="Tataouine">Tataouine</option>
                      <option value="Tozeur">Tozeur</option>
                      <option value="Tunis">Tunis</option>
                      <option value="Zaghouan">Zaghouan</option>
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="address">Address</Label>
                    <TextInput
                      id="address"
                      name="address"
                      value={franchiseFormData.address}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="phone">Phone</Label>
                    <TextInput
                      id="phone"
                      name="phone"
                      type="tel"
                      pattern="[0-9]{8}"
                      value={franchiseFormData.phone}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="latitude">Latitude</Label>
                    <TextInput
                      id="latitude"
                      name="latitude"
                      type="number"
                      step="any"
                      value={franchiseFormData.latitude}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="longitude">Longitude</Label>
                    <TextInput
                      id="longitude"
                      name="longitude"
                      type="number"
                      step="any"
                      value={franchiseFormData.longitude}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>
                </div>

                {/* Account Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    Account Information
                  </h3>

                  <div>
                    <Label htmlFor="username">Username</Label>
                    <TextInput
                      id="username"
                      name="username"
                      value={franchiseFormData.username}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="password">Password</Label>
                    <TextInput
                      id="password"
                      name="password"
                      type="password"
                      value={franchiseFormData.password}
                      onChange={handleFranchiseChange}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="resellerId">Reseller</Label>
                    <Select
                      id="resellerId"
                      name="resellerId"
                      value={franchiseFormData.resellerId}
                      onChange={handleFranchiseChange}
                      required
                    >
                      <option value="">Select a reseller</option>
                      {resellers.map((reseller) => (
                        <option key={reseller._id} value={reseller._id}>
                          {reseller.name}
                        </option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="commercialId">Commercial</Label>
                    <Select
                      id="commercialId"
                      name="commercialId"
                      value={franchiseFormData.commercialId}
                      onChange={handleFranchiseChange}
                      required
                    >
                      <option value="">Select a commercial</option>
                      {commercials?.map((commercial) => (
                        <option key={commercial._id} value={commercial._id}>
                          {commercial?.FirstName} {commercial?.LastName}
                        </option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-4">
                <Button color="gray" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                <Button type="submit" color="blue" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner size="sm" className="mr-2" />
                      Creating...
                    </>
                  ) : (
                    "Create Franchise"
                  )}
                </Button>
              </div>
            </form>
          </Card>
        );

      default:
        return null;
    }
  };

  return (
    <div className="container w-full">
      <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-2 2xl:grid-cols-1 mb-4">
        <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
          <div className="w-full p-2">
            <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
              Ajouter un utilisateur
            </span>
          </div>
        </div>
      </div>

      {/* User Type Selection */}
      <Card className="mb-6">
        <div className="flex items-center gap-2 mb-6">
          <UserPlus className="h-6 w-6 text-blue-600" />
          <h2 className="text-xl font-semibold">Type d'utilisateur</h2>
        </div>
        <div className="w-full">
          <Label htmlFor="userType">Sélectionnez le type d'utilisateur</Label>
          <Select
            id="userType"
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
            required
          >
            <option value="">Choisissez un type</option>
            <option value="PDV">Point de Vente (PDV)</option>
            <option value="COMMERCIAL">Commercial</option>
            <option value="FRANCHISE">Franchise</option>
          </Select>
        </div>
      </Card>

      {/* Dynamic Form Rendering */}
      {renderForm()}
      {success && (
        <SuccessModal
          show={success}
          onClose={() => setSuccess(false)}
          message="User created successfully"
        />
      )}
      {error && (
        <ErrorModal show={error} onClose={() => setError("")} message={error} />
      )}
    </div>
  );
};
